export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.payload.data = nuxtApp.payload.data || reactive({})
})
